import { FormUtils } from './../../FormUtils';
import { Component, OnInit } from '@angular/core';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { EntitlementService } from '../../services/entitlement.service';
import { CardholderService } from '../../services/cardholder.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Note } from '../../Note';
import { MessageService } from '../../services/message.service';
import { NCConstants } from '../../data/NCConstants';
import { NoteCategory } from '../../data/NoteCategory';
import {CardholderDetails} from "../../data/CardholderDetails";
import {Card} from "../../data/Card";

@Component({
  selector: 'app-cardholder-notes',
  templateUrl: './cardholder-notes.component.html',
  styleUrls: ['./cardholder-notes.component.css']
})
export class CardholderNotesComponent implements OnInit {
  cardholder: ProfileSearchResult;
  notesForm: UntypedFormGroup;
  save_a_btn: boolean;
  note_btn_spinner: string;
  note_type: string;
  disabled: boolean;
  categories;
  note_case: string;
  note_detail: string;
  notes: Note[];
  noteTypes = [];
  noteCat = '';
  note_detail_size: number;
  chipOnly: boolean;
  cardsAccount: Card[];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private entitlementService: EntitlementService,
    private cardHolderService: CardholderService,
    private formUtils: FormUtils
  ) { }

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
    this.loadData();
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;
    this.loadData();
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  loadData() {
    this.initForms();
    this.loadNoteCategories();
  }

  dropdownChange() {
    const cat = this.categories;
    for (let i = 0; i < cat.length; i++) {
      if (this.notesForm.get('note_cat').value === cat[i].name) {
        this.noteTypes = cat[i].types;
        this.notesForm.patchValue({
          note_type: ''
        });
        break;
      }
    }
  }

  loadNoteCategories() {
    this.cardHolderService.getNoteCategory().subscribe(
      (data: NoteCategory[]) => {
        const catArr: string[] = [];
        const keys: string[] = [];
        const jsonArr = [];
        for (let i = 0, j = 0; i < data.length; i++) {
          if (catArr[data[i].name]) {
            catArr[data[i].name] = catArr[data[i].name] + ',' + data[i].type;
          } else {
            catArr[data[i].name] = data[i].type;
            keys[j++] = data[i].name;
          }
        }
        for (let i = 0; i < keys.length; i++) {
          jsonArr.push({
            name: keys[i],
            types: catArr[keys[i]].split(',')
          });
        }
        this.cardHolderService.getCardholderDetails(this.cardholder.payrollAccount).subscribe(
          (data: CardholderDetails) => {
            this.cardsAccount = data.cardList;
          },
          (error) => {
            this.messageService.error('Error finding card holder details: ' + error);
          },
          () => {
            this.checkChipOnly();
            this.cardHolderService.chipDetails(this.chipOnly);
          })

        this.categories = jsonArr;
        this.loadNotes();
      },
      error => {
        if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
          this.messageService.error(error.data);
        } else {
          this.messageService.error(error.message);
        }
      }
    );
  }

  loadNotes() {
    this.cardHolderService.getNotes(this.cardholder.payrollAccount).subscribe(
      (data: Note[]) => {
        this.notes = data;
      },
      error => {
        if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
          this.messageService.error(error.data);
        } else {
          this.messageService.error(error.message);
        }
      }
    );
  }

  initForms() {
    this.save_a_btn = false;
    this.note_btn_spinner = '';
    this.note_type = '';
    this.disabled = false;
    this.categories = [];
    this.note_case = '';
    this.note_detail = '';
    this.notes = <Note[]>[];
    this.noteCat = '';
    this.note_detail_size = 0;

    this.notesForm = this.formBuilder.group({
      note_cat: [this.noteCat, [Validators.required]],
      note_type: [this.note_type, [Validators.required]],
      note_detail: [null, [Validators.required]],
      note_case: [this.note_case, []]
    });

    this.notesForm.get('note_detail').valueChanges.subscribe(value => {
      this.note_detail_size = value.toString().length;
    });
  }

  saveNote(): boolean {
    this.formUtils.markFormFieldsAsTouched(this.notesForm);
    if (!this.notesForm.valid) {
      return false;
    }
    this.note_btn_spinner = 'fa fa-spinner fa-spin';
    this.save_a_btn = true;
    this.cardHolderService
      .saveNote(
        this.cardholder.payrollAccount,
        this.notesForm.get('note_cat').value,
        this.notesForm.get('note_type').value,
        this.notesForm.get('note_case').value,
        this.notesForm.get('note_detail').value.trim()
      )
      .subscribe(
        (data: Note[]) => {
          this.notes = data;
          this.messageService.success('Saved Successfully');
          this.notesForm.patchValue({
            note_cat: '',
            note_type: '',
            note_detail: '',
            note_case: ''
          });
          this.notesForm.markAsUntouched();
          this.note_btn_spinner = '';
          this.save_a_btn = false;
        },
        error => {
          this.save_a_btn = false;
          if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
            this.messageService.error(error.data);
          } else {
            this.messageService.error(error.message);
          }
        }
      );
  }

  checkChipOnly() {
    const index = this.cardsAccount.findIndex(x => x.type !== 'CHIP');
    this.chipOnly = index < 0;
  }
}
